<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="50px"
          @submit.native.prevent
          inline
        >
          <el-form-item label="部门" prop="department_id">
            <el-select v-model="filter.department_id" size="small">
              <el-option
                v-for="(value, name) in DepartmentCategoryMap"
                :key="name"
                :label="value"
                :value="parseInt(name)"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="分类" prop="category_id">
            <category-select
              @change="filter.category_id = $event"
              :val="filter.category_id"
              :departmentID="filter.department_id"
            ></category-select>
          </el-form-item>
          <el-form-item label="件号" prop="part_number">
            <el-input
              size="small"
              v-model="filter.part_number"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
            >
            </el-input>
            <el-checkbox class="hot-button" v-model="filter.promotion"
              >🔥 促销中</el-checkbox
            >
          </el-form-item>
          <!-- <el-form-item label="分类" prop="category_ids">
            <category-group-select
              @change="filter.category_ids = $event"
              :val="filter.category_ids"
            ></category-group-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <!-- <div class="mt-10">
          <el-button type="primary" size="small" @click="requestSearch"
            >筛选</el-button
          >
          <el-button size="small" @click="requestSearch('reset')"
            >重置</el-button
          >
        </div> -->
      </div>
    </div>

    <div class="panel mt-20">
      <el-row v-loading="loading" v-if="!isMobile()">
        <el-col :span="4" class="item-li" v-for="item in list" :key="item.id">
          <el-card :body-style="{ padding: '0px' }" class="card-padding">
            <div class="image-container">
              <span class="promotion-tag" v-if="item.promotion">促销中</span>
              <auth-img
                tag="el-image"
                class="image"
                :src="item.cover"
                :preview-src-list="[item.cover]"
                fit="cover"
              ></auth-img>
            </div>
            <div
              style="padding: 12px; position: relative"
              :class="item.promotion ? 'promotion' : ''"
            >
              <template v-if="!item.new_part_number">
                <span class="item-price"
                  ><em>￥</em>{{ item.dealer_price.toFixed(2) }}
                  <span class="font-12 price_tag">（不含税）</span>
                </span>

                <div class="item-price origin-price">
                  ￥{{ item.price.toFixed(2) }}
                </div>
              </template>
              <template v-else
                ><span class="item-price">￥ -.-- </span>
                <div class="item-price origin-price">￥ -.--</div>
              </template>
              <h6 class="item-part-number">
                {{ item.part_number }}
                <span class="font-12">
                  （{{ item.type == 1 ? '备件' : '服务' }}）</span
                >
              </h6>
              <p class="item-desc">
                {{ item.description }} {{ item.description_zh }}
              </p>
              <div class="bottom clearfix">
                <el-button
                  type="text"
                  size="mini"
                  v-if="item.new_part_number"
                  @click="
                    ;(filter.part_number = item.new_part_number),
                      requestSearch()
                  "
                  >替代件号： {{ item.new_part_number }}</el-button
                >
                <el-button
                  v-else
                  size="mini"
                  round
                  type="danger"
                  v-permission="Auth.commodityOrderManage"
                  @click="addCart(item)"
                  >加入购物车</el-button
                >
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <ul v-else class="list-style">
        <li v-for="(item, index) in list">
          <div class="flex-row-between dealer">
            <div style="margin-right: 10px; display: flex; position: relative">
              <auth-img
                tag="el-image"
                style="width: 100px; height: 100px"
                :src="item.cover"
                :preview-src-list="[item.cover]"
                fit="cover"
              >
                <div slot="error" class="image-slot">暂无图片</div>
              </auth-img>
              <el-tag
                v-if="item.promotion"
                effect="dark"
                class="cmy-promotion"
                type="danger"
                size="mini"
                >促销中</el-tag
              >
            </div>
            <div class="dealer-list-right">
              <div class="top">
                <div class="font-14">
                  <span style="font-weight: bold" class="mr-5">
                    {{ item.part_number }}（{{
                      item.type == 1 ? '备件' : '服务'
                    }}）</span
                  >
                </div>
                <div class="font-12 desc" v-if="item.new_part_number">
                  替代件号：{{ item.new_part_number }}
                </div>
                <div class="font-12 desc b">
                  {{ item.description }} {{ item.description_zh }}
                </div>
              </div>
              <div class="font-14 text-danger">
                <template v-if="!item.new_part_number">
                  <span class="item-price"
                    ><em>￥</em>{{ item.dealer_price.toFixed(2)
                    }}<span
                      style="font-size: 10px; color: #9e9e9e; font-weight: 300"
                      >（不含税）</span
                    ></span
                  >
                  <span class="item-price origin-price ml-0"
                    >￥{{ item.price.toFixed(2) }}</span
                  >
                </template>
                <template v-else
                  ><span class="item-price">￥ -.-- </span></template
                >
              </div>
            </div>
          </div>
        </li>
      </ul>

      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <el-badge
      :value="cartCount"
      class="shopping-car"
      v-permission="Auth.commodityOrderManage"
    >
      <router-link tag="div" to="/dashboard/shop/carts"
        >购物车 <i class="el-icon-shopping-cart-full"></i
      ></router-link>
    </el-badge>
  </div>
</template>

<script>
import { commodityList, createCart, cartList } from '@/service/getData'
import CategorySelect from '@/components/select/commodity_category_select'
import CategoryGroupSelect from '@/components/select/commodity_category_group_select'
import { isMobile } from '../../../util'
import { clone } from '@/util'
import { DepartmentCategoryMap } from '@/config/global'

export default {
  components: {
    CategorySelect,
    CategoryGroupSelect,
  },
  data() {
    return {
      DepartmentCategoryMap,
      loading: false,
      editIndex: 0,
      isMobile,
      list: [],
      cartCount: 0,
      total: 0,
      filter: {
        size: 20,
        page: 1,
        name: '',
        part_number: '',
        status: 1,
        category_id: '',
        department_id: '',
        category_ids: [],
        promotion: false,
      },
    }
  },
  watch: {
    $route: function () {
      this.requestSearch('reset')
    },
  },
  created() {
    this.getData()
    this.getCarts()
  },
  methods: {
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },
    async addCart(item) {
      let res = await createCart({ commodity_id: item.id })
      if (res.code == 0) {
        this.getCarts()
        this.$emit('updateGoingCount')
        this.$message({
          message: '已加入购物车',
          type: 'success',
          center: true,
        })
      }
    },
    async getData() {
      this.loading = true
      let params = clone(this.filter)
      params.page -= 1

      if (params.category_ids.length > 0) {
        params.category_ids = params.category_ids.join('&category_ids=')
      }

      // params.promotion = this.$route.name == 'product_promotion_promoting'
      let res = await commodityList(params)
      this.list = res.data.list
      this.total = res.data.total
      this.loading = false
    },
    async getCarts() {
      let res = await cartList()
      if (res.code == 0) {
        this.cartCount = res.data.list.length
      }
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.name = ''
        this.filter.promotion = false
        this.filter.part_number = ''
        this.filter.category_id = ''
        this.filter.department_id = ''
        this.filter.category_ids = []
      }
      this.getData()
    },
  },
}
</script>
<style scoped>
.shopping-car {
  position: fixed;
  right: 35px;
  top: 36%;
}

.shopping-car div {
  display: flex;
  align-items: center;
}

.shopping-car div i {
  font-size: 24px;
}

.shopping-car div {
  padding: 9px 12px;
  font-size: 12px;
  border-radius: 3px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #e65252;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
}

.card-padding {
  width: 94%;
  margin: 0 auto;
  margin-bottom: 15px;
}

.image-container {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
}

.promotion-tag {
  position: absolute;
  top: 8px;
  z-index: 10;
  background: #e65252;
  color: #fff;
  text-align: center;
  padding: 3px 30px;
  left: -27px;
  transform: rotate(315deg);
  font-size: 12px;
}

.bottom {
  margin-top: 10px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.item-li {
  width: 220px !important;
}

/deep/.el-badge__content {
  font-size: 12px;
  padding: 0 6px;
}

.item-desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 54px;
  color: #666;
  margin-bottom: 0px;
  margin-top: 4px;
  font-size: 12px;
}

.item-price {
  color: #e4393c;
  font-size: 16px;
  font-weight: bold;
}

.item-price em {
  position: relative;
  left: -2px;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
}

.item-part-number {
  color: #666;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.promotion {
  background: #fdeadd;
}

.hot-button {
  margin: 0px 40px;
  color: #e65252;
}

.dealer.flex-row-between {
  justify-content: flex-start;
}

.dealer-list-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100px;
}

.dealer-list-right .desc {
  line-height: 1.3;
  margin-top: 2px;
}

.desc.b {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dealer .cmy-promotion {
  border-radius: 0 !important;
  border: none !important;
  position: absolute;
  left: 0;
  top: 0;
}

.price_tag {
  color: #a7a7a7;
  /* position: absolute; */
  /* top: 0; */
  /* left: 12px; */
  /* font-weight: 300; */
}
</style>